(() => {
  const designMode = Boolean(window.Shopify?.designMode);
  const storage = {
    get(key) {
      try { return JSON.parse(window.localStorage.getItem(key) || '{}'); }
      catch (error) { return {}; }
    },
    set(key, value) {
      try { window.localStorage.setItem(key, JSON.stringify(value)); }
      catch (error) {}
    }
  };

  const syncOverlayState = () => {
    document.body?.classList.toggle('aph-overlay-open', document.querySelectorAll('dialog[open]').length > 0 || document.body?.classList.contains('aph-menu-open'));
  };

  const showPopup = (popup) => {
    if (!popup || popup.open) return;
    if (popup.dataset.showMobile === 'false' && window.matchMedia('(max-width: 699px)').matches) return;
    try { popup.showModal(); }
    catch (error) { popup.setAttribute('open', ''); }
    syncOverlayState();
    window.setTimeout(() => popup.querySelector('input[type="email"]')?.focus({ preventScroll: true }), 80);
  };

  const closePopup = (popup, remember = true) => {
    if (!popup) return;
    if (remember && !designMode) {
      const key = popup.dataset.storageKey || 'ad-newsletter-popup-v2';
      const days = Math.max(1, Number(popup.dataset.dismissDays || 7));
      const state = storage.get(key);
      if (!state.subscribed) state.dismissedUntil = Date.now() + days * 86400000;
      storage.set(key, state);
    }
    if (typeof popup.close === 'function' && popup.open) popup.close();
    else popup.removeAttribute('open');
    syncOverlayState();
  };

  const initPopup = (popup) => {
    if (!popup || popup.dataset.aphBound === 'true') return;
    popup.dataset.aphBound = 'true';

    const key = popup.dataset.storageKey || 'ad-newsletter-popup-v2';
    const form = popup.querySelector('[data-aph-newsletter-modal-mailchimp-form]');
    const frame = popup.querySelector('[data-aph-newsletter-modal-frame]');
    const success = popup.querySelector('[data-aph-newsletter-modal-success]');
    const submit = popup.querySelector('[data-aph-newsletter-modal-submit]');
    let timer = null;
    let fallbackTimer = null;
    let submitted = false;

    const markSubscribed = () => {
      if (!submitted) return;
      submitted = false;
      if (fallbackTimer) window.clearTimeout(fallbackTimer);

      const state = storage.get(key);
      state.subscribed = true;
      state.subscribedAt = Date.now();
      delete state.dismissedUntil;
      storage.set(key, state);

      if (form) form.hidden = true;
      if (success) success.hidden = false;
      if (submit) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    };

    popup.querySelectorAll('[data-aph-newsletter-modal-close]').forEach((button) => {
      button.addEventListener('click', () => closePopup(popup, true));
    });

    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup(popup, true);
    });

    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup(popup, true);
    });

    popup.addEventListener('close', syncOverlayState);

    frame?.addEventListener('load', () => {
      if (submitted) window.setTimeout(markSubscribed, 120);
    });

    form?.addEventListener('submit', (event) => {
      if (!form.checkValidity()) return;
      submitted = true;
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
      }
      // Mailchimp responds inside the hidden iframe. This fallback keeps the UI
      // responsive even if the browser blocks the cross-origin frame render.
      fallbackTimer = window.setTimeout(markSubscribed, 2200);
    });

    if (designMode) {
      timer = window.setTimeout(() => showPopup(popup), 450);
    } else {
      const state = storage.get(key);
      if (state.subscribed) return;
      if (Number(state.dismissedUntil || 0) > Date.now()) return;
      timer = window.setTimeout(() => showPopup(popup), Math.max(0, Number(popup.dataset.delay || 4000)));
    }

    popup._adNewsletterPopupDestroy = () => {
      if (timer) window.clearTimeout(timer);
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
      if (popup.open) closePopup(popup, false);
    };
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.('[data-aph-newsletter-modal]').forEach(initPopup);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    const popup = event.target.querySelector?.('[data-aph-newsletter-modal]');
    if (popup) showPopup(popup);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.('[data-aph-newsletter-modal]').forEach((popup) => popup._adNewsletterPopupDestroy?.());
  });
})();
